import React, { useState } from 'react';
import { 
  FaUserFriends, FaCog, FaTrophy, FaArrowRight, 
  FaCheck, FaTruck, FaRegCreditCard, FaRegQuestionCircle, FaTree,
  FaCalculator, FaBitcoin, FaLink
} from "react-icons/fa";
import './Home.css';

// --- Component 1: StepCard (Updated) ---
const StepCard = ({ icon, title, subtitle, description }) => {
  return (
    <div className="step-card">
      <div className="step-top">
        <div className="icon-circle-wrapper">
          <div className="icon-circle">
            {/* Icon, Title, and Subtitle are now ALL inside the circle */}
            <div className="step-icon-container">{icon}</div>
            <h2 className="step-title">{title}</h2>
            <p className="step-subtitle">{subtitle}</p>
          </div>
        </div>
      </div>
      <div className="step-description-box">
        <p>{description}</p>
      </div>
    </div>
  );
};

// --- Component 2: PricingCard ---
const PricingCard = ({ variant, title, desc, checks, requirements, delivery, limits, pricingData }) => {
  return (
    <div className="pricing-card">
      <div className="card-header-badges">
        <span className="badge badge-primary">Varianta {variant}</span>
        <span className="badge badge-green"><FaTree /> Vánoční sleva</span>
      </div>
      <h3 className="card-title">{title}</h3>
      <p className="card-desc">{desc}</p>
      <div className="card-checks">
        {checks.map((check, i) => (
          <div key={i} className="check-row">
            <FaCheck className="check-icon" />
            <span>{check}</span>
          </div>
        ))}
      </div>
      <div className="info-block">
        <div className="info-row">
          <div className="info-icon"><FaRegQuestionCircle /></div>
          <div>
            <span className="info-label">Potřebujeme od vás</span>
            <p className="info-value">{requirements}</p>
          </div>
        </div>
        <div className="info-row">
          <div className="info-icon"><FaTruck /></div>
          <div>
            <span className="info-label">Doručení</span>
            <p className="info-value">{delivery}</p>
          </div>
        </div>
        <div className="info-row">
          <div className="info-icon"><FaRegCreditCard /></div>
          <div>
            <span className="info-label">Limity</span>
            <div className="info-value-multiline">
              {limits.map((l, i) => <div key={i}>{l}</div>)}
            </div>
          </div>
        </div>
      </div>
      <div className="price-footer">
        {pricingData.map((price, i) => (
          <div key={i} className={`price-row ${i > 0 ? 'border-top' : ''}`}>
            <span className="poplatek-label">POPLATEK</span>
            <div className="price-numbers">
              <span className="old-price">{price.old}</span>
              <span className="new-price">{price.new}</span>
            </div>
            <span className="price-sub">{price.sub}</span>
            {price.note && <span className="price-note">{price.note}</span>}
          </div>
        ))}
      </div>
    </div>
  );
};

// --- Component 3: CalculatorSection ---
const CalculatorSection = () => {
  const [orderValue, setOrderValue] = useState("");
  const [selectedRate, setSelectedRate] = useState(0.30);
  const [currency, setCurrency] = useState("CZK");

  const handleCalculate = () => {
    if (!orderValue) return "Zadejte hodnotu objednávky";
    const num = parseFloat(orderValue);
    if (isNaN(num)) return "Neplatná hodnota";
    const fee = Math.round(num * selectedRate);
    return `Poplatek: ${fee} ${currency === 'CZK' ? 'Kč' : '€'}`;
  };

  return (
    <div className="calc-payment-wrapper">
      {/* Calculator Card */}
      <div className="calculator-card">
        <div className="calc-header">
          <div className="calc-title-group">
            <FaCalculator className="calc-icon" />
            <h3>Výpočet Poplatku</h3>
          </div>
          <div className="currency-toggle">
            <button 
              className={`curr-btn ${currency === 'CZK' ? 'active' : ''}`} 
              onClick={() => setCurrency('CZK')}>Kč</button>
            <button 
              className={`curr-btn ${currency === 'EUR' ? 'active' : ''}`} 
              onClick={() => setCurrency('EUR')}>€</button>
          </div>
        </div>

        <div className="calc-body">
          <div className="input-group">
            <label>Hodnota objednávky ({currency === 'CZK' ? 'Kč' : '€'})</label>
            <input 
              type="number" 
              placeholder="Např. 50000" 
              value={orderValue}
              onChange={(e) => setOrderValue(e.target.value)}
            />
          </div>

          <div className="variant-group">
            <label>Vyberte variantu</label>
            <div className="variant-buttons">
              <button 
                className={`var-btn ${selectedRate === 0.20 ? 'active' : ''}`}
                onClick={() => setSelectedRate(0.20)}
              >
                <span className="var-percent">20%</span>
                <span className="var-label">Nová</span>
              </button>
              <button 
                className={`var-btn ${selectedRate === 0.25 ? 'active' : ''}`}
                onClick={() => setSelectedRate(0.25)}
              >
                <span className="var-percent">25%</span>
                <span className="var-label">Starší</span>
              </button>
              <button 
                className={`var-btn ${selectedRate === 0.30 ? 'active' : ''}`}
                onClick={() => setSelectedRate(0.30)}
              >
                <span className="var-percent">30%</span>
                <span className="var-label">Var. A</span>
              </button>
            </div>
          </div>
        </div>

        <div className="calc-result-bar">
          {orderValue ? (
            <span className="result-text highlight">{handleCalculate()}</span>
          ) : (
            <span className="result-text">Zadejte hodnotu objednávky pro výpočet</span>
          )}
        </div>
      </div>

      {/* Payment Options Grid */}
      <div className="bottom-info-grid">
        <div className="info-card payment-options">
          <div className="card-header-simple">
            <FaRegCreditCard className="header-icon-green" />
            <h3>Možnosti platby</h3>
          </div>
          <div className="payment-buttons-list">
            <button className="payment-btn">
              <div className="icon-circle-small"><FaBitcoin /></div>
              <span>Crypto</span>
            </button>
            <button className="payment-btn">
              <div className="icon-circle-small"><FaRegCreditCard /></div>
              <span>Platební karta</span>
            </button>
          </div>
          <div className="payment-footer-note">
              Pro další info se nás zeptej na telegramu: <span className="highlight-link">
              <a
                href="https://t.me/alzarefund"
                target="_blank" 
                rel="noopener noreferrer"
                style={{ color: "blue", textDecoration: "underline" }}
              >
                @alzarefund
              </a>
            </span>
          </div>
        </div>

        <div className="info-card when-pay">
          <div className="card-header-simple">
            <FaRegQuestionCircle className="header-icon-green" />
            <h3>Kdy platím?</h3>
          </div>
          <div className="info-list-items">
            <div className="info-item">
              <FaLink className="item-icon" />
              <div className="item-text">
                <strong>Platba předem</strong>
                <p>Poplatek se platí vždy před zpracováním objednávky nebo refundace.</p>
              </div>
            </div>
            {/* <div className="info-item">
              <FaShieldAlt className="item-icon" />
              <div className="item-text">
                <strong>Bezpečný obchod</strong>
                <p>Můžeme obchod provést prostřednictvím middlemana <span className="highlight-link">@bezpecne</span>. Peníze nám middleman nepošle, dokud nepotvrdíte, že vám bylo doručeno to, co bylo slíbeno.</p>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

// --- Component 4: FAQSection ---
const FAQSection = () => {
  const faqs = [
    {
      id: 1,
      question: "Proč nabízíte tuto službu místo toho, abyste zboží sami vyzvedávali a dále prodávali?",
      answer: (
        <>
          <p>Protože je současný způsob fungování pro nás nejbezpečnější a nejméně náročný. Peníze máme k dispozici okamžitě a nemusíme se zdržovat tím, že bychom zboží týdny nebo měsíce prodávali.</p>
          <p style={{ marginTop: '10px' }}>Zkoušeli jsme spolupráci se službami, které nabízely okamžitý výkup za polovinu hodnoty zboží, ale nebyli spolehlivy.</p>
        </>
      )
    }
  ];

  return (
    <section className="faq-section-container">
      <h2 className="section-title">Často kladené otázky</h2>
      <div className="faq-list">
        {faqs.map((faq) => (
          <div key={faq.id} className="faq-card">
            <h3 className="faq-question">{faq.question}</h3>
            <div className="faq-answer">{faq.answer}</div>
          </div>
        ))}
      </div>
    </section>
  );
};

// --- Main Component: Home ---
const Home = () => {
  const steps = [
    {
      id: 1,
      title: "Insider síť",
      subtitle: "Máme insidery uvnitř Alzy",
      description: "Insiders pro nás vyřizují refunds (vrácení peněz).",
      icon: <FaUserFriends />,
    },
    {
      id: 2,
      title: "Proces",
      subtitle: "Okamžité schválení",
      description: "V systému je zaevidováno, že zásilka nebyla doručena. Díky insiderům se běžné vyšetřování obchází.",
      icon: <FaCog />,
    },
    {
      id: 3,
      title: "Výsledek",
      subtitle: "Zboží + Peníze zpět",
      description: "Tímhle dokážem objednat cokoliv z Alzy, ponechat si zboží a dostat peníze od Alzy zpět.",
      icon: <FaTrophy />,
    }
  ];

  return (
    <div className="home-container grid-background">
      <header className="header-container">
        <div className="logo-pill">alzarefunds.cz</div>
      </header>

      <main className="content-wrapper">
        {/* Process Section */}
        <div className="process-grid">
          {steps.map((step, index) => (
            <React.Fragment key={step.id}>
              <StepCard 
                icon={step.icon}
                title={step.title}
                subtitle={step.subtitle}
                description={step.description}
              />
              {index < steps.length - 1 && (
                <div className="arrow-container">
                  <FaArrowRight className="step-arrow" />
                </div>
              )}
            </React.Fragment>
          ))}
        </div>

        {/* Offer Section */}
        <section className="offer-section">
          <h2 className="section-title">Co teda nabízíte?</h2>
          <div className="pricing-grid">
            <PricingCard 
              variant="A"
              title="Objednání zboží přes nás"
              desc="My zaplatíme celou objednávku a vy si zboží pouze vyzvednete"
              checks={["Zboží vám zůstane", "Peníze NÁM pošle Alza zpět"]}
              requirements="Odkaz na produkty + místo doručení"
              delivery="Alzabox, Pickup Pointy, Prodejna"
              limits={["Max. objednávka: 200 000 Kč / 8000 Eur", "Min. poplatek: 1000 Kč / 40 Eur"]}
              pricingData={[{ old: "35%", new: "30%", sub: "z hodnoty objednávky" }]}
            />
            <PricingCard 
              variant="B"
              title="Refund vašich objednávek"
              desc="Objednáte si zboží sami a insider vám zajistí refund"
              checks={["Zboží vám zůstane", "Peníze VÁM Alza pošle zpět"]}
              requirements="Pouze číslo objednávky"
              delivery="Vaše adresa, Alzabox, Pickup Pointy, Prodejna"
              limits={["Max. objednávka: 200 000 Kč / 8000 Eur", "Min. poplatek: 1000 Kč / 40 Eur"]}
              pricingData={[
                { old: "25%", new: "20%", sub: "z hodnoty objednávky", note: "Nová objednávka" },
                { old: "30%", new: "25%", sub: "z hodnoty objednávky", note: "Starší (2 týdny - 3 měsíce)" }
              ]}
            />
          </div>
        </section>

        {/* Calculator & Payment Section */}
        <section className="calculator-section-container">
          <CalculatorSection />
        </section>

        {/* FAQ Section */}
        <FAQSection />

      </main>
    </div>
  );
};

export default Home;